<template>
  <div class="stock-rsi-view">
    <StockRSI />
  </div>
</template>

<script>
import StockRSI from '@/components/indicators/StockRSI.vue'

export default {
  name: 'StockRSIView',
  components: {
    StockRSI
  }
}
</script>

<style scoped>
.stock-rsi-view {
  padding: 20px;
  flex: 1;
}
</style>
